import { AuthError } from '@azure/msal-browser';

const isAuthenticationError = (error: unknown): boolean => error instanceof AuthError;

export default isAuthenticationError;
